import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import MUIModal from '../../common/MUIModal';
import { apiConstants, postGeneric } from '../../common/constants';
import { getMerchant } from '../../helpers/ReduxHelpers';
import Pods from '../orders/list2/Pods';
import { FONT, SIZE, WEIGHT } from '../../styles/foundation/typography';
import { errorText } from './constants';

/**
 * "View" for a received PoD on PoD Analytics. The analytics rows carry no file link, so this reads the shipment's
 * PoD files from order/search (scoped to the picked merchant, as every merchant list) and shows them in the same
 * "PODs Link" pop-up as Delivered shipments.
 */
export default function PodFileButton({ awb }) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);

  const open = async () => {
    setLoading(true);
    try {
      const merchantId = getMerchant()?.id;
      const res = await postGeneric(apiConstants.ORDER_LISTS, {
        andfilter: [
          { field: 'awbNumber', operator: 'eq', value: awb },
          ...(merchantId ? [{ field: 'merchantDetail.key', operator: 'eq', value: merchantId }] : []),
        ],
        offset: 0,
        limit: 1,
        skipCount: true,
        includes: ['awbNumber', 'pods'],
      });
      const found = res?.data?.data?.[0];
      if (found?.pods?.length) setOrder(found);
      else enqueueSnackbar('No PoD file found for this shipment', { variant: 'warning' });
    } catch (e) {
      enqueueSnackbar(errorText(e, 'Could not load the PoD. Please try again.'), { variant: 'error' });
    }
    setLoading(false);
  };

  return (
    <>
      <Button size='small' variant='outlined' onClick={open} disabled={loading}
        startIcon={loading ? <CircularProgress size={12} /> : <OpenInNewOutlined sx={{ fontSize: 14 }} />}
        sx={{ textTransform: 'none', fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, py: 0.25 }}>
        View
      </Button>
      <MUIModal open={!!order} handleClose={() => setOrder(null)} title='PODs Link'>
        {order && <Pods id={order} />}
      </MUIModal>
    </>
  );
}
